module.exports = __webpack_public_path__ + "b75b1be8c85d192e9588b8c17ffe2386.png";